var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#8e909e"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.3142 10.3973c0-1.19762-.8914-2.11349-2.0571-2.11349s-2.0571.91587-2.0571 2.11349c0 1.1977.8914 2.1136 2.0571 2.1136s2.0571.9158 2.0571 2.1135-.8914 2.1135-2.0571 2.1135-2.0571-.9158-2.0571-2.1135",
    strokeLinejoin: "bevel",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.2571 6.69873v1.05676",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.2571 17.2664v1.0567",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "m21.4937 12.5003c0-5.24687-4.1399-9.5003-9.2468-9.5003-5.10694 0-9.2469 4.25343-9.2469 9.5003 0 5.2469 4.13996 9.5003 9.2469 9.5003 5.1069 0 9.2468-4.2534 9.2468-9.5003z",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/pay.4d6c5398841ba6490a393c7be8c9bf58.svg";
export { ForwardRef as ReactComponent };